'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Divider, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { WelcomePageWrapper } from '@/app/(blank-layout-pages)/welcomePageWrapper';
import { DomainInput } from '@/components/form/domainInput';
import { Link } from '@/components/shared/link';
import { isValidTenant } from '@/contexts/environment';
export const LoginV2DomainPage = () => {
  const $ = _c(27);
  const [domain, setDomain] = useState("");
  const [focused, setFocused] = useState(true);
  const onLogin = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      gap: "40px",
      overflow: "hidden",
      width: "680px",
      maxWidth: "100%"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Typography variant="h1" sx={{
      maxWidth: "540px",
      wordWrap: "break-word"
    }}>Log in with your account’s domain</Typography>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      alignItems: "center",
      gap: "16px"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setFocused(false);
    t4 = () => setFocused(true);
    t5 = {
      htmlInput: {
        "data-testid": "login-domain"
      }
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      width: "308px"
    };
    t7 = e => {
      const newValue = e.target.value;
      if (/^[a-zA-Z0-9-]*$/.test(newValue)) {
        setDomain(newValue);
      }
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== domain) {
    t8 = event => {
      if (event.key === "Enter") {
        onLogin(domain);
      }
    };
    $[8] = domain;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== domain || $[11] !== focused || $[12] !== t8) {
    t9 = <DomainInput autoFocus={true} focused={focused} onBlur={t3} onFocus={t4} slotProps={t5} value={domain} sx={t6} onChange={t7} onKeyUp={t8} />;
    $[10] = domain;
    $[11] = focused;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = !domain;
  let t11;
  if ($[14] !== domain) {
    t11 = () => onLogin(domain);
    $[14] = domain;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <i className="material-symbols-arrow-right-alt ml-[8px] align-middle" />;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== t10 || $[18] !== t11) {
    t13 = <Button className="h-full" disabled={t10} data-testid="login-button" variant="contained" onClick={t11}>Log In{t12}</Button>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== t13 || $[21] !== t9) {
    t14 = <Stack direction="row" sx={t2}>{t9}{t13}</Stack>;
    $[20] = t13;
    $[21] = t9;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <Divider sx={{
      borderStyle: "dashed",
      borderColor: "var(--mui-palette-divider)"
    }} />;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Stack direction="row" sx={{
      alignItems: "center",
      gap: "8px"
    }}><Typography>{"Don't have an account?"}</Typography><Link className="font-bold no-underline" href="https://www.eon.io/get-a-demo" target="_blank">Sign Up</Link></Stack>;
    $[24] = t16;
  } else {
    t16 = $[24];
  }
  let t17;
  if ($[25] !== t14) {
    t17 = <WelcomePageWrapper><Stack sx={t0}>{t1}{t14}{t15}{t16}</Stack></WelcomePageWrapper>;
    $[25] = t14;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  return t17;
};
function _temp(value) {
  if (!isValidTenant(value)) {
    return;
  }
  const params = new URLSearchParams(window.location.search);
  params.set("domain", value);
  window.location.assign(`/login?${params.toString()}`);
}